export interface VerifyGoogleToken {
  token: string;
}

export interface VerifyAppleToken {
  token: string;
  appId: string;
}

export enum AuthHandler {
  /*
   * POPUP is our default OAuth method for the web flow - the OAuth provider UI is opened in a separate
   * window, with the result passed back in an onSuccess callback. This works for all our pure web flows,
   * and can be used to launch authentication within other contexts, such as the Transaction flow
   * */
  POPUP = 'POPUP',
  /*
   * REDIRECT can be used in situations where the POPUP behaviour is blocked, such as within native Webviews.
   * In this flow, the web page navigates to the provider's UI in the same window, and the result is passed back to use
   * via the redirect URL that we provide. A couple of caveats here:
   * - This can only be used for the isolated Authentication flow. We cannot use this for authentication within other flows
   * (such as Transaction), since we lose our callback context to return the result back to the calling flow
   * - Google currently blocks the OAuth in webviews, so we cannot use the redirect flow for Google in Webviews
   * */
  REDIRECT = 'REDIRECT',
}

export interface OAuthTypeConfig {
  support: AuthHandler;
}

export interface OAuthConfiguration {
  supportedTypes: { [key: string]: OAuthTypeConfig };
}

export enum LoginActions {
  Authenticate = 'authenticate',
  GoogleRequested = 'google_requested',
  AppleRequested = 'apple_requested',
}

export enum AuthTokenType {
  Yoop = 'yoop',
  External = 'external',
}
